export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_SHOWCASE_ACTIVE_TAB = 'SET_SHOWCASE_ACTIVE_TAB';
